import { render } from "./settlementList.vue?vue&type=template&id=017d0bfd&scoped=true&ts=true"
import script from "./settlementList.vue?vue&type=script&lang=ts"
export * from "./settlementList.vue?vue&type=script&lang=ts"

import "./settlementList.vue?vue&type=style&index=0&id=017d0bfd&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-017d0bfd"]])

export default __exports__